export const toStringWithCommas = (n: number) => {
	return n.toLocaleString()
}
